import { DEAL } from '../../core/constants'
import { customParseFloat, durationToDateParser } from '../misc'

/**
 * Global modifications need to exist in global parser here
 * Custom logical changes or minor nuances must be handled in
 * respective children parsers
 */
export const standardDealParser = deal => {
  // Import object params as per documentation
  const stdDeal = {
    dealCode: deal?.code,
    isAR: deal?.is_auto_renewable,
    netIRR: deal?.net_irr_to_be_given_to_investor_percentage,
    originalDuration: deal?.credit_period_in_days,
    graceDuration: deal?.grace_period_for_investor_in_days,
    minPurchaseAmount: deal?.minimum_purchase_amount,
    progressBar: true,
    totalAmount: deal?.consideration_amount,
    soldAmount: deal?.new_funded_amount,
    dealReportUrl: deal?.deal_report?.document_id,
    logo: deal?.deal_brand?.document_id,
  }

  const { netIRR, originalDuration, graceDuration } = stdDeal

  stdDeal.type = DEAL.STANDARD
  stdDeal.netIRR = customParseFloat(netIRR)
  stdDeal.duration = originalDuration + graceDuration

  return { ...stdDeal }
}

export const standardSecondaryDealParser = deal => {
  const stdSecDeal = {
    dealCode: deal?.deal_transaction_code,
    isAR: deal?.is_auto_renewable,
    netIRR: deal?.net_irr_to_be_given_to_investor_percentage,
    duration: deal?.secondary_investment_tenure,
    minPurchaseAmount: deal?.secondary_consideration_amount,
    dealLiquidationId: deal?.id,
    isSecondary: true,
    maturityValue: deal?.net_tentative_maturity_value_rounded,
    maturityDate: deal?.financier_due_date,
    dealReportUrl: deal?.deal_report?.document_id,
    logo: deal?.deal_brand?.document_id,
  }

  const { netIRR } = stdSecDeal

  stdSecDeal.type = DEAL.STANDARD_SECONDARY
  stdSecDeal.netIRR = customParseFloat(netIRR)

  return { ...stdSecDeal }
}

export const debtDealParser = deal => {
  const debtDeal = {
    dealCode: deal?.code,
    netIRR: deal?.net_irr_to_be_given_to_investor_percentage,
    availableLots: deal?.available_lots,
    amountPerLot: deal?.current_consideration_amount_per_lot,
    debtTermsUrl: deal?.debt_terms?.document_id,
    logo: deal?.deal_brand?.document_id,
    isZC: true,
    isUnits: deal?.lots_or_units === 'UNITS',
  }

  const { netIRR } = debtDeal

  debtDeal.type = DEAL.DEBT
  debtDeal.netIRR = customParseFloat(netIRR)

  return { ...debtDeal }
}

export const debtSecondaryDealParser = deal => {
  const debtSecDeal = {
    baseDealCode: deal?.deal_code,
    dealCode: deal?.deal_transaction_code,
    netIRR: deal?.net_irr_to_be_given_to_investor_percentage,
    // UNTIL we support multiple lot purchase available lots is 1. Moreover secondary_consideration_amount is already pre multiplied with available_lots
    availableLots: 1,
    amountPerLot: deal?.secondary_consideration_amount,
    dealLiquidationId: deal?.id,
    isSecondary: true,
    debtTermsUrl: deal?.debt_terms?.document_id,
    logo: deal?.deal_brand?.document_id,
    isZC: true,
    isUnits: deal?.lots_or_units === 'UNITS',
  }

  const { netIRR } = debtSecDeal

  debtSecDeal.type = DEAL.DEBT_SECONDARY
  debtSecDeal.netIRR = customParseFloat(netIRR)

  return { ...debtSecDeal }
}

export const leaseDealParser = deal => {
  const leaseDeal = {
    dealCode: deal?.code,
    netIRR: deal?.net_irr_to_be_given_to_investor_percentage,
    minPurchaseAmount: deal?.minimum_purchase_amount,
    considerationAmount: deal?.consideration_amount,
    logo: deal?.deal_brand?.document_id,
    totalUnits: deal?.number_of_units,
    residualPercentage: deal?.lease_residual_amount_percent,
    tdsPercentage: deal?.tds_on_rent_deducted_by_customer,
    progressBar: true,
    totalAmount: deal?.consideration_amount,
    soldAmount: deal?.new_funded_amount,
    totalNumberOfRentals: deal?.number_of_rental_payments,
    rentalFrequency: deal?.time_gap_between_rental_payments,
    rentalValue: deal?.amount_of_rent,
    rentalStartDuration: deal?.first_rental_due_in_days,
    dealReportUrl: deal?.deal_report?.document_id,
  }

  const { netIRR, tdsPercentage, rentalFrequency, totalNumberOfRentals } = leaseDeal

  leaseDeal.type = DEAL.LEASE
  leaseDeal.netIRR = customParseFloat(netIRR)
  leaseDeal.tdsPercentage = customParseFloat(tdsPercentage / 100)
  leaseDeal.rentalEndDate = durationToDateParser(rentalFrequency * totalNumberOfRentals)

  return { ...leaseDeal }
}

export const leaseSecondaryDealParser = () => {}
